import { Accordion, BorderedAccordionItem } from "components/Accordion";

type PaperDebugInfoProps = {
  debugInfo: any;
};

// Renders additional model feature sections (Phase 1 and Phase 2) when available,
// plus the full raw debug JSON blob from the paper_search endpoint.
function PaperDebugInfo({ debugInfo }: PaperDebugInfoProps) {
  const phase1Features = (debugInfo as any)?.phase1_features;
  const phase2Features = (debugInfo as any)?.phase2;

  const hasPhase1 = phase1Features && Object.keys(phase1Features).length > 0;
  const hasPhase2 = phase2Features && Object.keys(phase2Features).length > 0;

  return (
    <div className="mt-6">
      <Accordion defaultOpen="debug-info">
        {[
          hasPhase1 && (
            <BorderedAccordionItem
              key="phase1-model-features"
              itemKey="phase1-model-features"
              title="Phase 1 model features"
              content={
                <div className="mt-4 p-4 bg-bg-faint rounded-2xl sm:leading-[150%]">
                  <pre className="text-xs whitespace-pre-wrap break-words hyphens-auto">
                    {JSON.stringify(phase1Features, null, 2)}
                  </pre>
                </div>
              }
            />
          ),
          hasPhase2 && (
            <BorderedAccordionItem
              key="phase2-model-features"
              itemKey="phase2-model-features"
              title="Phase 2 model features"
              content={
                <div className="mt-4 p-4 bg-bg-faint rounded-2xl sm:leading-[150%]">
                  <pre className="text-xs whitespace-pre-wrap break-words hyphens-auto">
                    {JSON.stringify(phase2Features, null, 2)}
                  </pre>
                </div>
              }
            />
          ),
          <BorderedAccordionItem
            key="debug-info"
            itemKey="debug-info"
            title="Debug Info"
            content={
              <div className="mt-4 p-4 bg-bg-faint rounded-2xl sm:leading-[150%]">
                <pre className="text-xs whitespace-pre-wrap break-words hyphens-auto">
                  {JSON.stringify(debugInfo, null, 2)}
                </pre>
              </div>
            }
          />,
        ].filter(Boolean)}
      </Accordion>
    </div>
  );
}

export default PaperDebugInfo;
